<template>
  <v-container>
    <v-row class="pt-1">
      <h3>Base Conditions</h3>
    </v-row>
    <v-row>
      <v-col cols="12">
        <input-handler :path="`${path}.slabOrPiers`" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <input-handler :path="`${path}.baseTrim`" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "BaseCondition",

  props: {
    buildingIndex: String,
  },

  computed: {
    path() {
      return `buildings[${this.buildingIndex}].baseCondition`
    },
  },

  components: {
    InputHandler: () =>
      import(
        /* webpackChunkName: 'InputHandler' */
        "@/components/input/InputHandler"
      ),
  },
}
</script>
